export enum LeadTypes {
  INTERNET = 'INTERNET',
  IMPORT = 'IMPORT',
  PARTS_ORDER = 'PARTS_ORDER',
  PHONE = 'PHONE',
  PREVIOUS_CUSTOMER = 'PREVIOUS_CUSTOMER',
  REFERRAL = 'REFERRAL',
  SERVICE = 'SERVICE',
  WALK_IN = 'WALK_IN',
  WEBSITE_CHAT = 'WEBSITE_CHAT',
  WHOLESALE = 'WHOLESALE',
}

export const defaultLeadTypeOption = {
  leadType: [
    {
      value: LeadTypes.INTERNET,
      label: LeadTypes.INTERNET,
    },
  ],
};

export const LeadTypeKey = 'leadType';
